import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const Label = styled.p`
  color: ${COLORS.secondarySemiDark};
  font-size: 14px;
  font-weight: 500;
`

export const Ratio = styled.span`
  color: ${COLORS.secondarySemiDark};
  font-size: 12px;
  font-weight: 400;
  opacity: 0.7;
  margin-inline-start: auto;
  padding-inline-end: 15px;
`
